<template>
  <div class="directory-form-container">
    <el-form :model="directoryForm" :rules="rules" ref="directoryForm" label-width="100px" class="demo-directoryForm">
      <el-form-item label="目录路径" prop="path">
        <el-input v-model="directoryForm.path">
          <template slot="prepend">{{path}}</template>
          <template slot="append">/</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('directoryForm')">立即创建</el-button>
        <el-button @click="resetForm('directoryForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { fileManageApi } from '@/api/index';
let validateDirectoryPath = (rule, value, callback) => {
  if (/^((\w|\-|\_|\.)+)$/.test(value)) {
    callback()
  } else {
    callback(new Error(`目录只能有一层结构，可用数字、字母、下划线、连接符创建目录`,))
  }
}
export default {
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      directoryForm: {
        path: '',
      },
      rules: {
        path: [
          { validator: validateDirectoryPath, required: true, trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const path = `${this.path}${this.directoryForm.path}/`;
          const res = await fileManageApi.addDirectory({ path });
          if (res.code === 200) {
            this.$message.success('创建成功！');
            this.$emit('close');
            this.$emit('getDirectoryFiles');
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style>
</style>